<template>
    <div id="door-sidebar-menu" class="sidebar-menu-container">
        <div class="sidebar-main-label">Коррекция перекрытия</div>
        <div class="sidebar-text-area">В случае, если на вашей фотографии присутствуют посторонние <span class="red-text bold-text">объекты на переднем плане</span>, Вы можете воспользоваться функцией коррекции перекрытия, позволяющей <span class="red-text bold-text">скрыть участки плоскостей</span> проекта.</div>
        <div class="sidebar-step-two-img-container">
            <img class="sidebar-step-two-img" :src="urlForStatic('/img/fix_overlap_tip.png')"/>
        </div>
        <div class="sidebar-text-area"><span class="red-text bold-text">Ограничьте объект</span> переднего плана контуром, если он заграждает собой здание, расставляя поочерёдно точки по его периметру, как показано на рисунке ниже.</div>
        <div class="sidebar-step-two-img-container">
            <img class="sidebar-step-two-img" :src="urlForStatic('/img/fix_overlap_tip_2.png')"/>
        </div>
        <div class="sidebar-text-area">После того, как периметр фигуры, обрамляющей объект на фото, будет замкнут, нажмите кнопку <span class="red-text bold-text">"Готово"</span>. При необходимости, точки фигуры можно перемещать после расстановки.</div>
    </div>
</template>

<script>
    import {urlForStaticVue} from "../../common";

    export default {
        name: "OverlapSidebarMenu",
        mixins: [urlForStaticVue]
    }
</script>

<style scoped>

</style>
